module.exports = __webpack_public_path__ + "static/img/13.baf2af59.jpg";